import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SessionGuard implements CanActivate {

  constructor(private router: Router){}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    let userData = localStorage.getItem('userData');
    if (localStorage.getItem('isUserLoggedin') && userData) {  // Check if the user is logged in
        let role = JSON.parse(userData)['role']
        this.router.navigate([role == 1 ? '/map-view' : '/category']);
        return false;
    } else {
        return true;
      }
  }

}